import theme from "@/theme";

export const styles = {
  dialogPaper: {
    borderRadius: "16px",
    padding: "20px 21px",
    width: "452px",
    height: "238px",
    margin: "0",
    backgroundColor: "#ffffff",
  },

  dialogBackdrop: (isTransparent: boolean) => ({
    backgroundColor: isTransparent ? "transparent !important" : "#ffffff90 !important",
  }),

  closeButton: {
    position: "absolute",
    right: 15,
    top: 15,
    cursor: "pointer",
  },

  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  penIconWrapper: {
    borderRadius: "50%",
    width: "410px",
    height: "38px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mb: 1.25,
  },

  title: {
    fontSize: "22px",
    lineHeight: "22px",
    fontWeight: "bold",
    color: "#0078ff",
    mb: 4,
  },

  subtitle: {
    fontSize: "18px",
    lineHeight: "32px",
    textAlign: "center",
    marginBottom: "1rem",
    color: theme.palette.custom.blueGray800,
    fontWeight: 500,
  },

  buttonGroup: {
    display: "flex",
    gap: 2,
    justifyContent: "center",
    width: "100%",
    height: "48px",
  },

  postTypeButton: {
    borderRadius: 28,
    backgroundColor: "#0078ff",
    "&:hover": { backgroundColor: "#0056b3" },
    minWidth: "126px",
    textTransform: "none",
    fontWeight: "700",
    padding: "0.75rem",
  },
};
